import { I18nComponente } from "@/types/gerais"

export const MBotoesRodapei18n: I18nComponente = {
  "pt-BR": {
    salvar: "salvar",
    cancelar: "cancelar"
  },
  "es-CO": {
    salvar: "guardar",
    cancelar: "cancelar"
  }
}
